import FontFamily from '@tiptap/extension-font-family';
import { getStyleProperty } from '@tiptap/core';

let knownFonts = null;

const readKnownFonts = () => {
  const meta = document.querySelector('meta[name=supported-fonts]')?.content;
  if (meta) {
    return JSON.parse(meta);
  }

  const controls = document.querySelectorAll('[data-command="font:family"]');
  return Array.from(controls).map((control) => control.value);
};

const supportedFonts = () => {
  if (!knownFonts?.length) {
    knownFonts = readKnownFonts();
  }
  return knownFonts;
};

export const canonicalFontName = (value) => {
  const bare = String(value ?? '')
    .replace(/['"]/g, '')
    .trim();

  if (!bare) {
    return null;
  }

  return supportedFonts().find((font) => font.toLowerCase() === bare.toLowerCase()) || null;
};

export const cssFontFamily = (value) => {
  const known = canonicalFontName(value);

  if (!known) {
    return value;
  }

  return known.includes(' ') ? `'${known}'` : known;
};

export const CanonicalFontFamily = FontFamily.extend({
  addGlobalAttributes() {
    return this.parent().map((group) => ({
      ...group,
      attributes: {
        ...group.attributes,
        fontFamily: {
          ...group.attributes.fontFamily,
          parseHTML: (element) => {
            const value = getStyleProperty(element, 'font-family') ?? element.style.fontFamily;
            return value ? canonicalFontName(value) || value : value;
          },
          renderHTML: (attributes) => {
            if (!attributes.fontFamily) {
              return {};
            }
            return { style: `font-family: ${cssFontFamily(attributes.fontFamily)}` };
          },
        },
      },
    }));
  },
});
